module.exports = __webpack_public_path__ + "media/images/lb/563-a0ae98948c80a1d478fc192bd410f314.svg";